/**
 * Distintivo de suscripción activa.
 *
 * El estado real vendrá de `profiles.is_vip`, y esa columna la escribirá el
 * webhook de RevenueCat en la Fase 5 — nunca el cliente. Aquí el componente solo
 * pinta lo que le den.
 */

import { Crown } from 'lucide-react';

interface VIPBadgeProps {
  active: boolean;
  /** Fecha ISO de caducidad, solo para el tooltip. */
  expiresAt?: string | null;
  className?: string;
}

export function VIPBadge({ active, expiresAt, className = '' }: VIPBadgeProps) {
  if (!active) return null;

  const title = expiresAt
    ? `Pase VIP activo hasta ${new Date(expiresAt).toLocaleDateString('es-ES')}`
    : 'Pase VIP activo';

  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 rounded-full border border-amber-300/70 bg-linear-to-r from-amber-500 to-yellow-400 px-2 py-0.5 text-[10px] font-black tracking-wider text-amber-950 uppercase shadow-md ${className}`}
    >
      <Crown className="h-3 w-3" aria-hidden />
      VIP
    </span>
  );
}
